module.exports = __webpack_public_path__ + "static/robothor-reconfiguration-3d0e5c11e3b803ffa32f060ca1076d3f.gif";